export type PlacesPageLoaderType =
    | 'PlacesWorkplanLoader'
    | 'PlacesHomeRouteLayoutLoader'
    | 'PlacesBuildingLoader';

export function isPlacePageLoaderType(loaderType: string): loaderType is PlacesPageLoaderType {
    return (
        loaderType === 'PlacesWorkplanLoader' ||
        loaderType === 'PlacesHomeRouteLayoutLoader' ||
        loaderType === 'PlacesBuildingLoader'
    );
}
